import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { dashboards } from '../constants/dashboards';
import { LoginModal } from '../components/LoginModal/LoginModal';

const MySwal = withReactContent(Swal);

export const openLoginModal = () => {
  if (dashboards.length === 1) {
    window.open(dashboards[0].link);
  } else {
    MySwal.fire({
      html: <LoginModal />,
      showConfirmButton: false,
      width: 'max-content',
    });
  }
};
